import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IModelService } from 'vscode/vscode/vs/editor/common/services/model';
import { ITextModelService } from 'vscode/vscode/vs/editor/common/services/resolverService';
import { Disposable, dispose } from 'vscode/vscode/vs/base/common/lifecycle';
import { IUndoRedoService } from 'vscode/vscode/vs/platform/undoRedo/common/undoRedo.service';
import { MultiModelEditStackElement } from 'vscode/vscode/vs/editor/common/model/editStack';

let ModelUndoRedoParticipant = class ModelUndoRedoParticipant extends Disposable {
    constructor(_modelService, _textModelService, _undoRedoService) {
        super();
        this._modelService = _modelService;
        this._textModelService = _textModelService;
        this._undoRedoService = _undoRedoService;
        this._register(this._modelService.onModelRemoved((model) => {
            const elements = this._undoRedoService.getElements(model.uri);
            if (elements.past.length === 0 && elements.future.length === 0) {
                return;
            }
            for (const element of elements.past) {
                if (element instanceof MultiModelEditStackElement) {
                    element.setDelegate(this);
                }
            }
            for (const element of elements.future) {
                if (element instanceof MultiModelEditStackElement) {
                    element.setDelegate(this);
                }
            }
        }));
    }
    prepareUndoRedo(element) {
        const missingModels = element.getMissingModels();
        if (missingModels.length === 0) {
            return Disposable.None;
        }
        const disposablesPromises = ( missingModels.map(async (uri) => {
            try {
                const reference = await this._textModelService.createModelReference(uri);
                return reference;
            }
            catch (err) {
                return Disposable.None;
            }
        }));
        return Promise.all(disposablesPromises).then(disposables => {
            return {
                dispose: () => dispose(disposables)
            };
        });
    }
};
ModelUndoRedoParticipant = ( __decorate([
    ( __param(0, IModelService)),
    ( __param(1, ITextModelService)),
    ( __param(2, IUndoRedoService))
], ModelUndoRedoParticipant));

export { ModelUndoRedoParticipant };
